import axios from "axios";
import { useTranslation } from "react-i18next";

const getCurrentPosition = (): Promise<GeolocationPosition> => {
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(resolve, reject);
  });
};

export const useLocate = () => {
  const { i18n } = useTranslation();

  const locate = async () => {
    if (!navigator.geolocation) {
      return { address: "", street: "", streetNumber: "" };
    }

    const position = await getCurrentPosition();
    const { latitude, longitude } = position.coords;
    let address = "";
    let street = "";
    let streetNumber = "";

    const res = await axios.get(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${
        import.meta.env.VITE_GOOGLE_MAPS_API_KEY
      }&language=${i18n.language}`
    );

    const { results } = res.data;
    const components = results[0].address_components;
    address = results[0].formatted_address;

    for (const component of components) {
      if (component.types.includes("route")) {
        street = component.long_name;
      }
      if (component.types.includes("street_number")) {
        streetNumber = component.long_name;
      }
    }

    return { address, street, streetNumber };
  };

  return { locate };
};
